<template>
  <v-card class="d-flex align-stretch pl-2 pt-2 pb-2" elevation="0">
    <!-- Column 1 -->

    <!-- Left column  -->
    <card-custom
      class="d-inline"
      event_name="indicator"
      :show_dropdown_state="true"
      :dropdown_state="cardMessage.indicator"
      outlined
      elevation="1"
      style="width: 25%; height: 100%;"
    >
      <template v-slot:prepend_icon>
        <icon icon="uis:microscope" height="24px" color="grey" />
      </template>

      <template v-slot:title>
        <div class="text-subtitle-2">{{ $t('_indicateurs_') }}</div>
      </template>

      <template v-slot:teaser>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="datePicked"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="datePicked"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="datePicked"
            :min="auditStartDate"
            :max="auditEndDate"
            elevation="10"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="menu = false"
            >
              {{ $t('_annuler_') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="refreshDate(datePicked)"
            >
              {{ $t('_rafraichir_') }}
            </v-btn>
          </v-date-picker>
        </v-menu>

        <br>

        <score-bloc
          v-if="alarmIndicator !== undefined && alarmIndicator.availability !== undefined"
          event_name="disponibility_score"
          text_align="left"
          indicator_color="black"
          :indicator_text="alarmIndicator.availability.value + '%'"
          desc_color="grey"
          :desc_text="$t('_disponibilite_(30_derniers_jours)_')"
          :icon_type="alarmIndicator.availability.tendency"
        />

        <score-bloc
          v-if="alarmIndicator !== undefined && alarmIndicator.performance_score !== undefined"
          event_name="model_loss_score"
          text_align="left"
          indicator_color="black"
          :indicator_text="alarmIndicator.performance_score.value + '%'"
          desc_color="grey"
          :desc_text="$t('_pertes_vs_modele_(energie)_')"
          :icon_type="alarmIndicator.performance_score.tendency"
        />

        <score-bloc
          v-if="alarmIndicator !== undefined && alarmIndicator.actionable_losses !== undefined"
          event_name="recovery_loss_score"
          text_align="left"
          indicator_color="black"
          :indicator_text="alarmIndicator.actionable_losses.value + '%'"
          desc_color="grey"
          :desc_text="$t('_pertes_recouvrables_')"
          :icon_type="alarmIndicator.actionable_losses.tendency"
        />

      </template>

      <template v-slot:content>
        <v-treeview
          v-if="alarmLossTree !== undefined"
          :items="alarmLossTree"
          :transition="true"
          open-on-click
          dense
        >
          <template v-slot:label="{ item }">
            <span
              v-if="item.level == 0"
              v-bind:style="'color: #000000'"
            >
              {{ $t(item.name) }}
            </span>

            <span
              v-else-if="item.level == 1"
              v-bind:style="'color: rgba(0,0,0,.6)'"
            >
              {{ $t(item.name) }}
            </span>
          </template>

          <template v-slot:append="{ item }">
            <span
              v-if="item.level == 0"
              v-bind:style="'color: #000000; padding-left: 10px;'"
            >
              <b>{{ String(item.loss_value_rounded) + ' %' }}</b>
            </span>

            <span
              v-else-if="item.level == 1"
              v-bind:style="'color: rgba(0,0,0,.6); padding-left: 10px;'"
            >
              <b>{{ String(item.loss_value_rounded) + ' %' }}</b>
            </span>
          </template>

        </v-treeview>
      </template>
    </card-custom>

    <!-- Right column -->
    <v-card class="d-flex flex-column px-2" flat elevation="0" width="100%">

      <!-- Row 2 : Alarmes / Incidents -->
      <card-custom
        class="d-flex flex-column mb-2"
        event_name="alarm"
        :show_dropdown_state="true"
        :dropdown_state="cardMessage.alarm"
        outlined
        elevation="1"
        style="width: 100%;"
      >
        <template v-slot:prepend_icon>
          <icon icon="jam:triangle-danger" height="24px" color="grey" />
        </template>

        <template v-slot:title>
          <div class="text-subtitle-2">{{ $t('_alarmes_incidents_') }}</div>
        </template>

        <template v-slot:content>
          <v-container :key="refresh_key" class="d-flex flex-column px-0 py-0">
            <v-row justify="space-between" align="center">
              <v-col width="100%"></v-col>

              <v-col cols="3">
                <v-select
                  v-model="date_filter"
                  :items="date_option"
                  :label="$t('_selectionnez_une_periode_a_filtrer_')"
                  outlined
                  dense
                  class="text-subtitle-2"
                  @change="refreshAlarm()"
                ></v-select>
              </v-col>

              <v-col cols="3">
                <v-select
                  v-model="alarm_status"
                  :items="alarm_option"
                  :label="$t('_selectionnez_un_statut_a_filtrer_')"
                  outlined
                  dense
                  class="text-subtitle-2"
                  @change="refreshAlarm()"
                ></v-select>
              </v-col>
            </v-row>

            <v-row justify="space-between" align="center">
              
               
                <!-- <div v-for = "item in filters" :key="item">
                  {{ item.items }}
                </div> -->
                <v-col v-for = "(filter, key) in filters" 
                :key="'filter' + key"
                :style="'width: 10%; height:10%'">

                
                  <v-select
                    style
                    clearable
                    
                    v-model="filter.values"
                    :items="filter.items"
                    :label="filter.text"
                    outlined
                    dense
                    multiple

                    @change="refreshFilter()"
                  >
                  <template v-slot:selection="{ index }">
                    <div v-if="index == 0">
                      {{ filter.values.length }}
                    </div>
                  </template>

                  <template v-slot:item="{ active, item, attrs, on }">
                  <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                    <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title v-if="filter.text != $t('_categorie_')">
                        {{ item }}
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        <icon
                          :icon="item"
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                </v-select>
              </v-col>
              
            </v-row>

            <v-row justify="space-between" align="center" v-if="alm_inc_data !== undefined">
              <v-col width="100%">
                <v-data-table
                  id="alm_inc"
                  :key="refresh_key"
                  :headers="alm_inc_header"
                  :items="alm_inc_data_filter"
                  :footer-props="{
                    'items-per-page-options': [20, 50, 100, -1],
                    'items-per-page-text': this.$t('_lignes_par_page_'),           
                  }"
                  :items-per-page="10"
                  :item-key="alm_inc_data_filter.id"
                  :single-expand="true"
                  :expanded.sync="alarmExpanded"
                  show-expand
                  dense
                  
                >

                  <template v-slot:item.cat_checklist="{ item }">
                  </template>

                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <ul class="mx-0 my-2" style="line-height: 1.25rem">
                        <li v-for="msg in splitBySeparator(item.message, '\n')" :key="msg">
                          {{ msg }}
                        </li>
                      </ul>
                    </td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </card-custom>

      <!-- Row 1 : Résultats d'examen -->
      <card-custom
        class="d-flex flex-column"
        event_name="checklists"
        :show_dropdown_state="true"
        :dropdown_state="cardMessage.checklists"
        outlined
        elevation="1"
        style="width: 100%;"
        v-if="checklistCategories !== undefined && checklistTables !== undefined"
      >
        <template v-slot:prepend_icon>
          <icon icon="tabler:checkup-list" height="24px" color="grey" />
        </template>

        <template v-slot:title>
          <div class="text-subtitle-2">{{ $t('_resultats_d_examen_') }}</div>
        </template>

        <template v-slot:teaser>
         <v-container class="d-flex flex-column px-0 py-0">
            <v-row justify="space-between" >
              <v-col min-width="50%">

                <!-- Card_custom : sysacq_trdata -->
                <card-custom
                  event_name="checklists"
                  :show_dropdown_state="false"
                  :dropdown_state="cardMessage.checklists"
                  outlined
                  elevation="0"
                  style="width: 100%;"
                >
                  <template v-slot:prepend_icon>
                    <icon
                      :icon="checklistIcon['sysacq_trdata']['icon']"
                      :height="checklistIcon['sysacq_trdata']['height']"
                      :color="checklistIcon['sysacq_trdata']['color']"
                    />
                  </template>

                  <template v-slot:title>
                    <div class="d-flex align-center">
                      <div class="text-subtitle-3 justify-start" style="width: 100%">
                        {{ $t(getChecklistCatDescription('sysacq_trdata')) }}
                      </div>
                      <checklist-status :data="checklistStatus['sysacq_trdata']" />
                    </div>
                  </template>

                  <template v-slot:content>
                    <v-container class="d-flex flex-column px-0 py-0">
                      <item-table
                        v-if="checklistTables !== undefined"
                        :key="checklist_key"
                        :datatable="checklistTables['sysacq_trdata']"
                        dense
                      />
                    </v-container>
                  </template>
                </card-custom>
              </v-col>

              <v-col min-width="50%">
                <!-- Card_custom : net_env -->
                <card-custom
                  event_name="checklists"
                  :show_dropdown_state="false"
                  :dropdown_state="cardMessage.checklists"
                  outlined
                  elevation="0"
                  style="width: 100%;"
                >
                  <template v-slot:prepend_icon>
                    <icon
                      :icon="checklistIcon['net_env']['icon']"
                      :height="checklistIcon['net_env']['height']"
                      :color="checklistIcon['net_env']['color']"
                    />
                  </template>

                  <template v-slot:title>
                    <div class="d-flex align-center">
                      <div class="text-subtitle-3 justify-start" style="width: 100%">
                        {{ $t(getChecklistCatDescription('net_env')) }}
                      </div>
                      <checklist-status :data="checklistStatus['net_env']" />
                    </div>
                  </template>

                  <template v-slot:content>
                    <v-container class="d-flex flex-column px-0 py-0">
                      <item-table
                        v-if="checklistTables !== undefined"
                        :key="checklist_key"
                        :datatable="checklistTables['net_env']"
                        dense
                      />
                    </v-container>
                  </template>
                </card-custom>
              </v-col>
            </v-row>

            <v-row justify="space-between" >
              <v-col min-width="50%">
                <!-- Card_custom : inv -->
                <card-custom
                  event_name="checklists"
                  :show_dropdown_state="false"
                  :dropdown_state="cardMessage.checklists"
                  outlined
                  elevation="0"
                  style="width: 100%;"
                >
                  <template v-slot:prepend_icon>
                    <icon
                      :icon="checklistIcon['inv']['icon']"
                      :height="checklistIcon['inv']['height']"
                      :color="checklistIcon['inv']['color']"
                    />
                  </template>

                  <template v-slot:title>
                    <div class="d-flex align-center">
                      <div class="text-subtitle-3 justify-start" style="width: 100%">
                        {{ $t(getChecklistCatDescription('inv')) }}
                      </div>
                      <checklist-status :data="checklistStatus['inv']" />
                    </div>
                  </template>

                  <template v-slot:content>
                    <v-container class="d-flex flex-column px-0 py-0">
                      <item-table
                        v-if="checklistTables !== undefined"
                        :key="checklist_key"
                        :datatable="checklistTables['inv']"
                        dense
                      />
                    </v-container>
                  </template>
                </card-custom>
              </v-col>

              <v-col min-width="50%">
                <!-- Card_custom : field_mod -->
                <card-custom
                  event_name="checklists"
                  :show_dropdown_state="false"
                  :dropdown_state="cardMessage.checklists"
                  outlined
                  elevation="0"
                  style="width: 100%;"
                >
                  <template v-slot:prepend_icon>
                    <icon
                      :icon="checklistIcon['field_mod']['icon']"
                      :height="checklistIcon['field_mod']['height']"
                      :color="checklistIcon['field_mod']['color']"
                    />
                  </template>

                  <template v-slot:title>
                    <div class="d-flex align-center">
                      <div class="text-subtitle-3 justify-start" style="width: 100%">
                        {{ $t(getChecklistCatDescription('field_mod')) }}
                      </div>
                      <checklist-status :data="checklistStatus['field_mod']" />
                    </div>
                  </template>

                  <template v-slot:content>
                    <v-container class="d-flex flex-column px-0 py-0">
                      <item-table
                        v-if="checklistTables !== undefined"
                        :key="checklist_key"
                        :datatable="checklistTables['field_mod']"
                        dense
                      />
                    </v-container>
                  </template>
                </card-custom>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </card-custom>
    </v-card>
  </v-card>
</template>

<script>

// import webconf from "../../utils/frontend_setup";

import api from "@/api/api";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import ScoreBloc from "../UI_kit/ScoreBloc.vue"
import CardCustom from "../UI_kit/CardCustom.vue"
import ItemTable from "../UI_kit/ItemTable.vue"
import ChecklistStatus from "../UI_kit/ChecklistStatus.vue"
import { Icon } from '@iconify/vue2'
import eventBus from "../../store/event_bus";
// import compdata from "../../utils/compute_data";



export default {
	components: {
    CardCustom,
    ItemTable,
    ChecklistStatus,
    ScoreBloc,
    Icon,
	},

	data() {
		return {

      refesh_filter :0,


      script_name: "Diagnostic.vue (Dashboard Niv2)",        // For debug
      installation_id: this.$route.params.id,
      refresh_key: 0,

      menu: null,

      datePicked: this.getAuditEndDate(),
      dateSelected: null,
      auditStartDate: this.$store.state.parametersStore.dates.start,
      auditEndDate: this.$store.state.parametersStore.dates.end,

      // ----------- Tables

      cardMessage: {
        "indicator": false,
        "alarm": true,
        "checklists": false,
        "sysacq_trdata": false,
        "net_env": false,
        "inv": false,
        "field_mod": false
      },

      // ---- Indicator
      alarmIndicator: null, // Start as null to prevent repeated fetches
      alarmLossTree: null,  // Start as null to prevent repeated fetches

      // ---- Checklist card
      checklistCategories: [],
      checklistIcon: {},
      checklistStatus: {},
      checklistTables: {},
      checklist_key: 0,

      filters: {},

      // ---- Alarm card
      alarmExpanded: [],
      alarmStatus: [],
      alm_inc_header: this.getAlarmTableHeader(),
      alm_inc_data: [],

      // -- Selects
      alarm_status: this.$t('_toutes_les_alarmes_'),
      alarm_option: [
        this.$t('_toutes_les_alarmes_'),
        this.$t('_alarmes_ouvertes_'),
        this.$t('_alarmes_fermees_')
      ],

      date_filter: this.$t('_dates_<_1_mois_'),
      date_option: [
        this.$t('_toutes_les_dates_'),
        this.$t('_dates_<_1_mois_'),
        this.$t('_dates_<_3_mois_')
      ],
		};
	},
  mounted() {
    eventBus
      .$on(`card_custom`, (obj) => {
        this.cardMessage[obj.component] = obj.state
      })
  },

  beforeDestroy() {
    eventBus.$off(`card_custom`)
  },

	watch: {
		route: {
      handler() {
        // Only call if route parameters have changed
        const newInstallationId = this.$route.params.id;
        if (this.installation_id !== newInstallationId) {
          this.installation_id = newInstallationId;
          this.refreshData();
        }
      },
			immediate: true,
		},

    '$root.$i18n.locale': {
      async handler() {
        await this.refreshPage()
			},
			immediate: true,
    },

	},

  computed: {
    auditDates() {
			return this.$store.state.parametersStore.dates
		},

    alm_inc_data_filter() {
      this.refesh_filter 
      let values = this.alm_inc_data
      let values_mid = []
      
      for (let filter in this.filters){
        if (filter != 'cat_checklist'){
          values_mid = values.filter((elem) => this.filters[filter]['values'].includes(elem[filter]))
        } else {
          values_mid = values.filter((elem) => this.filters[filter]['values'].includes(elem['icon']))
        }
        values = values_mid
      }
      return values
    }
  },

	methods: {

    refreshFilter(){
      this.refesh_filter  = this.refesh_filter  + 1
    },

    alm_inc_data_filter_funct() {
      let values = this.alm_inc_data
      let values_mid = []
      
      for (let filter in this.filters){
        if (filter != 'cat_checklist'){
          values_mid = values.filter((elem) => this.filters[filter]['values'].includes(elem[filter]))
        } else {
          values_mid = values.filter((elem) => this.filters[filter]['values'].includes(elem['icon']))
        }
        values = values_mid
        console.log(values_mid)
      }
      return values
    },
    
    setFilters() {
      for (let header in this.alm_inc_header){
        this.filters[this.alm_inc_header[header].value] = {}
        if (this.alm_inc_header[header].value !== 'cat_checklist'){
          let listElem = this.alm_inc_data
            .map((elem) => elem[this.alm_inc_header[header].value])
            .filter((elem, index, self) => self.indexOf(elem) === index);

            this.filters[this.alm_inc_header[header].value].values = listElem
            this.filters[this.alm_inc_header[header].value].items = listElem
            this.filters[this.alm_inc_header[header].value].text = this.alm_inc_header[header].text

        } else {
          let listElem = this.alm_inc_data
            .map((elem) => elem['icon'])
            .filter((elem, index, self) => self.indexOf(elem) === index);

          this.filters[this.alm_inc_header[header].value].values = listElem
          this.filters[this.alm_inc_header[header].value].items = listElem
          this.filters[this.alm_inc_header[header].value].text = this.$t(this.alm_inc_header[header].text)
          
        }
      }
    
    },

    async refreshPage(){
      
      this.alarm_status = this.$t('_toutes_les_alarmes_')
      this.alarm_option = [
        this.$t('_toutes_les_alarmes_'),
        this.$t('_alarmes_ouvertes_'),
        this.$t('_alarmes_fermees_')
      ]

      this.date_filter = this.$t('_dates_<_1_mois_')
      this.date_option = [
        this.$t('_toutes_les_dates_'),
        this.$t('_dates_<_1_mois_'),
        this.$t('_dates_<_3_mois_')
      ]

      this.alm_inc_header = this.getAlarmTableHeader()

      await this.getAlarmIndicator()
      await this.getAlarmLossTree()

      this.getChecklistIcon()
      await this.getChecklistStatus()
      await this.getChecklists()
      await this.getAlarmDetails()
      this.setFilters()
      this.refresh_key += 1
    },

    splitBySeparator(item, sep) {
      if (item !== undefined) {
        return item.substring(0, item.length - 1).split(sep)
      } else {
        return ''
      }
    },

    getAuditEndDate() {
      return this.$store.state.parametersStore.dates.end
    },

    // Checklists
    getChecklistCategories() {
      if (this.$store.getters.lang_code !== undefined) {
        api.getChecklistCategories()
          .then(res => {
            this.checklistCategories = res.data
          })
        }
    },

    getChecklistCatDescription(cat_code) {
      if (this.checklistCategories !== undefined && cat_code !== undefined) {
        return this.checklistCategories[cat_code]
      }
    },

    getChecklistIcon() {
      this.$store.getters.constants['alarm'].forEach((checklist) => {
        this.checklistIcon[checklist.key] = checklist['icon']
      })
    },

    async getChecklists() {
      if (this.$store.getters.cur_install_id !== undefined) {
        this.dateSelected = (this.datePicked !== undefined) ? this.datePicked : this.getAuditEndDate()

        await api.getChecklists(this.$store.getters.cur_install_id, this.dateSelected)
          .then(res => {
            this.checklistTables = res.data
            this.checklist_key++
          })
        }
    },

    async getChecklistStatus() {
      if (this.$store.getters.cur_install_id !== undefined) {
        this.dateSelected = (this.datePicked !== undefined) ? this.datePicked : this.getAuditEndDate()

        await api.getChecklistStatus(this.$store.getters.cur_install_id, this.dateSelected)
          .then(res => {
            this.checklistStatus = res.data
          })
        }
    },

    // Alarms
    getAlarmTableHeader() {
      return [
        {
          text: this.$t('_categorie_'),
          align: 'start',
          sortable: false,
          value: 'cat_checklist',
        },
        { text: this.$t('_sub_categorie_'), value: 'checklist_desc',
        },
        { text: this.$t('_type_d_alarme_'), value: 'alarm_type' },
        { text: this.$t('_criticite_'), value: 'criticity' },
        { text: this.$t('_statut_'), value: 'status' },
        { text: this.$t('_date_d_ouverture_'), value: 'open_date' },
        { text: this.$t('_date_de_fermeture_'), value: 'close_date' },
      ]
    },

    getFilterPeriodType() {
      if (this.date_filter !== undefined) {
        if (this.date_filter === this.$t('_toutes_les_dates_')) return 0
        if (this.date_filter === this.$t('_dates_<_1_mois_')) return 1
        if (this.date_filter === this.$t('_dates_<_3_mois_')) return 2
      } else
        return null
    },

    getFilterAlarmStatus() {
      if (this.alarm_status !== undefined) {
        if (this.alarm_status === this.$t('_toutes_les_alarmes_')) return 0
        if (this.alarm_status === this.$t('_alarmes_ouvertes_')) return 1
        if (this.alarm_status === this.$t('_alarmes_fermees_')) return 2
      } else
        return null
    },

    async getAlarmDetails() {
      if (this.$store.getters.cur_install_id !== undefined) {
        this.dateSelected = (this.datePicked !== undefined) ? this.datePicked : this.getAuditEndDate()

        this.alm_inc_data = []
        await api.getAlarmDetails(
            this.$store.getters.cur_install_id,
            this.dateSelected,
            this.getFilterPeriodType(),
            this.getFilterAlarmStatus()
        ).then(res => {
            this.alm_inc_data = res.data

            for (let i = 0; i < this.alm_inc_data.length; i++) {
              this.alm_inc_data[i].alarm_type = this.$t(this.alm_inc_data[i].alarm_type)
              this.alm_inc_data[i].checklist_desc = this.$t(this.alm_inc_data[i].checklist_desc)
              this.alm_inc_data[i].criticity = this.$t(this.alm_inc_data[i].criticity)
              this.alm_inc_data[i].message = this.$t(this.alm_inc_data[i].message)
              this.alm_inc_data[i].status = this.$t(this.alm_inc_data[i].status)
            }
          })
        }
    },

    async refreshAlarm() {
      await this.getAlarmDetails()
    },

    // Indicator
    async refreshDate(date) {
      this.$refs.menu.save(date)

      await this.getAlarmIndicator()
      await this.getAlarmLossTree()

      this.getChecklistIcon()
      await this.getChecklistStatus()
      await this.getChecklists()
      await this.getAlarmDetails()
    },

    getAlarmIndicator() {
      this.dateSelected = (this.datePicked !== undefined) ? this.datePicked : this.getAuditEndDate()

      api.getAlarmIndicator(this.$store.getters.cur_install_id, this.dateSelected)
          .then(res => {
            this.alarmIndicator = res.data
          })
    },

    // Loss treeview
    getAlarmLossTree() {
      this.dateSelected = (this.datePicked !== undefined) ? this.datePicked : this.getAuditEndDate()

      api.getAlarmLossTree(this.$store.getters.cur_install_id, this.dateSelected)
          .then(res => {
            this.alarmLossTree = res.data
            // Add treeview
          })
    },

	},
};
</script>

<style>
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > td {
    font-size: .75rem;
    height: 45px;
    line-height: 1.2;
  }

  #sys_acq > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
  #env_res > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
  #inv > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
  #field_mod > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
  #alm_inc > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2) {
    height: 50px;
    vertical-align: middle;
    background-color: #f7f7f7;
  }

  .table-text {
    font-family: Roboto,sans-serif;
    font-size: .75rem;
    font-weight: 400;
    text-align: left;
  }

  .text-subtitle-3 {
    font-size:.775rem!important;
    font-weight:500;
    line-height:1.25rem;
    letter-spacing:.0071428571em!important;
    font-family:Roboto,sans-serif!important;
    color: grey;
    
  }

</style>
